// @flow

import React from "react";
import classnames from "classnames";

import Styles from "./ProgressBar.module.scss";

type Props = {
  stepsCount: number,
  actualStep: number,
};

const ProgressBar = ({ stepsCount, actualStep }: Props) => {
  return (
    <div className={Styles.container}>
      {[...Array(stepsCount).keys()].map((step, index) => {
        return (
          <div
            key={"progressBarStep_" + index}
            className={classnames(Styles.step, { [Styles.green]: step + 1 <= actualStep })}
          ></div>
        );
      })}
    </div>
  );
};

export default ProgressBar;
